module.exports = __webpack_public_path__ + "static/media/corona.352d3d59.png";